import types from '../mutations/mutation-types';
import api from '../../utils/api';

export default {
  state: {
    smsapps: []
  },
  mutations: {
    [types.SLACK.LOAD_SMS_APPS](state, apps) {
      state.smsapps = apps;
    }
  },
  actions: {
    getApps({ commit }) {
      return new Promise((resolve) => {
        api.buildRequest('smsapps', 'GET')
          .then(({ data: { payload } }) => {
            const apps = payload.apps || [];
            const allApps = apps.map(each => ({ name: each.appName, value: `GENERIC_SMS_APP###${each.appName}` }));
            commit(types.SLACK.LOAD_SMS_APPS, allApps);
            resolve();
          });
      });
    },
    runCommandAction(context, { body, url }) {
      return new Promise((resolve, reject) => {
        api.buildRequest(url, 'POST', null, body)
          .then(({ status, data }) => {
            if (status === 401) {
              return reject('Please login again');
            }
            return status === 200 ? resolve(data.payload) : reject(data.payload);
          }).catch(() => {
            reject('Check your internet connection');
          });
      });
    }
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/slack.js